export const enum PropertyCardInteractionEvent {
  /**
   * Click on property card
   */
  clickProperty = 'clickProperty',
}
